import React from 'react';
import css from './css.module.less';
import QR from './QR';
import Pin from './Pin';
import { ModalFooter } from 'src/components/Antd';
import { QrcodeOutlined } from '@ant-design/icons';
// import { collectWithQRCode } from 'src/request/order';
import { Icon } from '@/src/tools/icon';
// import { message } from 'antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
export enum ECollectionType {
  QR = 'QR',
  Pin = 'Pin',
}
export enum EScanType {
  Image = 'Image',
  Barcode = 'Barcode',
}

const Collection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    type,
    onTitleChange,
    onCancel,
    onPinSubmit,
    pickupPersonName,
    onBarcodeSubmit,
    onQRSubmit,
    buyerName,
  } = props;
  const [cT, setCT] = React.useState(type || ECollectionType.QR);

  const [barcode, setBarcode] = React.useState('');
  const [barcodeError, setBarcodeError] = React.useState(null);
  const [scanType, setScanType] = React.useState(EScanType.Image);
  const [pin, setPin] = React.useState('');
  const [pinError, setPinError] = React.useState(null);
  const isQR = cT === ECollectionType.QR;

  const render = () => {
    if (cT === ECollectionType.QR) {
      return (
        <div>
          <QR
            onSubmit={onQRSubmit}
            barcode={barcode}
            handleOnBarcodeChange={(b) => {
              setBarcode(b);
              setBarcodeError(false);
              //setPinError(false);
            }}
            barcodeError={barcodeError}
            scanType={scanType}
            onScanTypeChange={(type) => {
              setScanType(type);
              setBarcodeError(false);
              // setPinError(false);
            }}
          />
        </div>
      );
    }
    if (cT === ECollectionType.Pin) {
      return (
        <div>
          <Pin
            value={pin}
            error={pinError}
            pickupPersonName={pickupPersonName}
            buyerName={buyerName}
            onChange={(pin) => {
              setPin(pin);
              setPinError(false);
            }}
          />
        </div>
      );
    }
    return null;
  };

  const isScanner = scanType === EScanType.Image && cT === ECollectionType.QR;
  const disabledOk = () => {
    if (isQR) {
      if (scanType === EScanType.Barcode) {
        if (!barcode) {
          return true;
        }
        if (barcodeError) {
          return true;
        }
      }
    }
    if (cT === ECollectionType.Pin) {
      if (!pin) {
        return true;
      }
      if (pinError) {
        return true;
      }
    }
    return false;
  };

  const handleOnSwitch = () => {
    if (cT === ECollectionType.QR) {
      setCT(ECollectionType.Pin);
      onTitleChange(
        getI18n(
          `allOrders.orderDetail.components_collection_handleOnSwitch_pin`,
        ),
      );
      setPin('');
      setPinError(false);
    }
    if (cT === ECollectionType.Pin) {
      setCT(ECollectionType.QR);
      onTitleChange(
        getI18n(
          `allOrders.orderDetail.components_collection_handleOnSwitch_qr`,
        ),
      );
      setBarcode('');
      setBarcodeError(false);
    }
  };

  return (
    <React.Fragment>
      {render()}

      <ModalFooter
        {...(!isScanner
          ? {
              hideOkButton: disabledOk(),
              onOk: () => {
                if (cT === ECollectionType.Pin) {
                  onPinSubmit(pin).then((res) => {
                    const { success } = res || {};
                    if (!success) {
                      const { errMsg } = res || {};
                      setPinError(errMsg);
                    }
                  });
                }
                if (cT === ECollectionType.QR) {
                  if (scanType === EScanType.Barcode) {
                    onBarcodeSubmit(barcode).then((res) => {
                      const { success } = res || {};
                      if (!success) {
                        const { errMsg } = res || {};
                        setBarcodeError(errMsg);
                      }
                    });
                  }
                }
                return;
              },
              onCancel,
            }
          : {})}
        front={
          <div className={css.modalFront} onClick={handleOnSwitch}>
            {isQR ? (
              <span>
                <Icon className={css.icon} type='iconpin' />
                {getI18n(
                  'allOrders.orderDetail.notified_return_category_btns_PINtext',
                )}
              </span>
            ) : (
              <span>
                <QrcodeOutlined className={css.icon} />
                {getI18n(
                  'allOrders.orderDetail.notified_return_category_btns_QRtext',
                )}
              </span>
            )}
          </div>
        }
      />
    </React.Fragment>
  );
};
export default Collection;
